import angular from 'angular';
import kformUtils from '~/components/kform/utils/kform-utils';

/**
 * @param {any} $scope
 * @param {import('angular').ITimeoutService} $timeout
 */
export default /* @ngInject */ ($scope, $timeout) => {
	if ($scope.options && $scope.options.building) {
		return;
	}
	// Ensure each data grid has a valid data model.
	$scope.data = $scope.data || {};
	$scope.data[$scope.component.key] = $scope.data[$scope.component.key] ?? [];

	// Determine if any component is visible.
	$scope.anyVisible = (/** @type {any} */ component) => {
		const data = ($scope.data && $scope.data[$scope.component.key]) ?? [];
		let visible = data.length === 0;
		for (const rowData of data) {
			visible = (
				visible || kformUtils.isVisible(component, rowData, $scope.data, $scope.hideComponents, $scope.form)
			);
		}
		return visible;
	};

	// Pull out the rows and cols for easy iteration.
	$scope.rows = $scope.data[$scope.component.key];
	// If less than card.from, add that many rows.
	if ($scope.data[$scope.component.key].length < $scope.component.validate.card.from) {
		const toAdd = $scope.component.validate.card.from - $scope.data[$scope.component.key].length;
		for (let index = 0; index < toAdd; index++) {
			$scope.addRow();
		}
	}
	// If more than card.to, remove extra rows.
	if ($scope.data[$scope.component.key].length > $scope.component.validate.card.to) {
		$scope.data[$scope.component.key].splice($scope.component.validate.card.to);
	}
	$scope.cols = $scope.component.components;
	$scope.localKeys = $scope.component.components.map((/** @type {any} */ component) => component.key);

	// Add a row the to grid.
	$scope.addRow = () => {
		if (!Array.isArray($scope.rows)) {
			$scope.data[$scope.component.key] = [];
		}
		$scope.data[$scope.component.key].push(
			Object.fromEntries($scope.cols.map((/** @type {any} */ col) => [col.key, []])),
		);
	};

	// Remove a row from the grid.
	$scope.removeRow = (/** @type {number} */ index) => {
		$scope.data[$scope.component.key].splice(index, 1);

		// sets the form in dirty state (because it doesn't do it!)
		if ($scope.$parent.$parent.kformForm) {
			$scope.$parent.$parent.kformForm.$setDirty();
		}
		$timeout(() => {
			angular.element(`#form-group-${$scope.component.key}`)
				?.trigger('rowRemoved');
		});
	};
};
